import reducer from "./contestSlice"

export * from "./contestSlice"

export default reducer
